import { css } from '@emotion/react/macro'

export const DocumentScreenBehaviour = css`
  width: 80rem;
  max-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

export const DocumentBelowNavbarBehaviour = css`
  padding-left: 1.8rem;
  padding-right: 1.8rem;
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const DocumentMainBehaviour = css`
  flex: 1;
`
